var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -0.005,
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F2FF"
    },
    d: "M145.953,453.007c0,0-99.887-19.757-104.979-89.554c-5.861-80.333,74.751-81.219,62.385-139.449 c-17.26-81.275,16.493-129.686,92.12-126.347c63.77,2.815,114.917,51.364,153.024,11.93 c39.609-40.988,104.276-82.62,172.384-53.941c68.109,28.679,58.075,121.871,105.178,141.673 c47.103,19.802,98.112,72.03,89.897,144.28c-7.707,67.784-70.219,112.819-128.143,112.136c-28.386-0.335-138.56,0.375-237.57,0 C247.216,453.346,145.953,453.007,145.953,453.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F2FF"
    },
    d: "M642.516,183.266c0,0-18.461-35.584,13.047-52.717c33.919-18.444,59.922,15.819,51.915,44.031 C699.472,202.79,652.345,201.538,642.516,183.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F2FF"
    },
    d: "M59.179,209.532c0,0-15.63-11.726-4.363-27.288c11.266-15.562,38.351-7.611,34.023,11.15 C86.867,201.944,75.822,220.698,59.179,209.532z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M578.208,453.303c-8.208,0.577-41.353,1.107-35.485-26.967 c2.997-14.338-4.63-15.919-12.002-23.147c-7.373-7.227-6.49-10.795-4.235-18.71c2.255-7.915-7.899-5.21-9.861-17.121 c-1.962-11.912,5.468-21.876,18.326-21.812c12.858,0.064,9.974,13.404,14.163,18.33c4.189,4.926,10.679,0.389,14.971,12.129 c4.292,11.74-1.964,18.754,6.263,23.342c1.471,0.82,3.033,1.971,4.613,3.361"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M564.417,421.371c-6.343-12.902-13.054-25.623-20.1-38.155 c-2.405-4.278-4.851-8.534-7.333-12.768c-0.488-0.832-1.785-0.078-1.295,0.757c7.915,13.502,15.447,27.229,22.553,41.174 c1.65,3.238,3.276,6.488,4.879,9.749C563.547,422.995,564.841,422.235,564.417,421.371L564.417,421.371z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M531.583,394.488c5.462,0.566,10.924,1.133,16.387,1.7c0.786,0.082,1.573,0.163,2.359,0.245 c0.959,0.099,0.952-1.401,0-1.5c-5.462-0.566-10.924-1.133-16.387-1.7c-0.786-0.082-1.573-0.163-2.359-0.245 C530.623,392.888,530.63,394.389,531.583,394.488L531.583,394.488z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M538.133,384.983c0,1.357-1.269,2.456-2.834,2.456 c-1.565,0-2.834-1.1-2.834-2.456c0-1.356,1.269-2.456,2.834-2.456C536.864,382.527,538.133,383.627,538.133,384.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M544.448,362.904c-0.783,1.355-2.516,1.82-3.872,1.037 c-1.356-0.783-1.82-2.516-1.037-3.871c0.783-1.356,2.516-1.82,3.872-1.038C544.766,359.815,545.23,361.548,544.448,362.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M555.86,427.214c0,1.691-1.582,3.061-3.532,3.061 c-1.951,0-3.533-1.37-3.533-3.061c0-1.691,1.582-3.061,3.533-3.061C554.278,424.152,555.86,425.523,555.86,427.214z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    cx: 538.131,
    cy: 355.646,
    r: 1.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M626.496,450.578c-6.796-4.846-7.465-35.579,20.388-41.799 c14.225-3.177,11.946-10.298,14.82-19.457c2.874-9.159,6.481-9.833,14.624-11.076c8.143-1.243,2.029-12.342,11.694-18.769 c9.665-6.427,22.638-6.921,27.471,7.127c4.092,11.894-7.499,17.133-9.863,22.664c-2.364,5.531,4.513,12.999-3.873,21.339 c-8.386,8.341-17.355,2.062-17.465,10.895c-0.109,8.833-4.035,24.927-12.549,28.238 C661.21,453.837,631.86,454.403,626.496,450.578z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M635.971,454.086c3.772-4.5,7.688-8.883,11.468-13.378 c9.343-11.111,18.467-22.407,27.378-33.867c6.484-8.338,12.852-16.765,19.087-25.29c0.571-0.78-0.73-1.529-1.295-0.757 c-10.467,14.31-21.304,28.347-32.45,42.134c-6.978,8.632-14.072,17.173-21.321,25.579c-1.303,1.51-2.647,2.99-3.928,4.519 C634.294,453.761,635.35,454.827,635.971,454.086L635.971,454.086z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M645.427,409.134c-0.626-5.143-1.438-10.182-1.902-14.867 c-1.884-19.048,24.37-10.534,34.827-34.978c10.457-24.444-15.143-33.327-3.103-43.556c12.039-10.229,15.4-45.377-2.235-51.421 c-22.862-7.836-43.41,6.497-46.203,25.376c-2.154,14.563,7.609,24.733-17.801,35.408 c-25.411,10.675-21.485,23.932-16.265,49.286c5.22,25.354-11.952,16.058-25.298,37.46 c-10.575,16.959,4.287,34.256,10.913,40.707l51.432,0.883"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M588.849,452.555c2.096-4.838,4.201-9.672,6.308-14.506 c5.17-11.864,10.359-23.721,15.567-35.569c6.637-15.098,13.304-30.183,20.024-45.244 c6.489-14.543,13.018-29.068,19.68-43.532c4.717-10.242,9.413-20.521,14.59-30.542c0.385-0.746,0.775-1.489,1.171-2.229 c0.456-0.851-0.839-1.609-1.295-0.757c-4.924,9.19-9.253,18.715-13.636,28.17c-6.551,14.133-12.952,28.335-19.313,42.553 c-6.796,15.192-13.533,30.41-20.238,45.642c-5.475,12.438-10.928,24.887-16.361,37.343 c-2.565,5.883-5.293,11.725-7.691,17.679c-0.032,0.079-0.068,0.156-0.102,0.234 C587.174,452.675,588.466,453.44,588.849,452.555L588.849,452.555z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M635.703,345.476c10.057-0.556,20.113-1.113,30.17-1.669 c1.438-0.08,2.876-0.159,4.314-0.239c0.96-0.053,0.966-1.553,0-1.5c-10.057,0.556-20.113,1.113-30.17,1.669 c-1.438,0.08-2.876,0.159-4.314,0.239C634.743,344.029,634.737,345.53,635.703,345.476L635.703,345.476z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M600.885,424.017c7.931-0.892,15.862-1.784,23.792-2.676 c1.135-0.128,2.269-0.255,3.404-0.383c0.948-0.107,0.959-1.608,0-1.5c-7.931,0.892-15.862,1.784-23.792,2.676 c-1.135,0.128-2.269,0.255-3.404,0.383C599.937,422.624,599.926,424.125,600.885,424.017L600.885,424.017z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M597.642,337.771c2.277,5.111,4.554,10.222,6.831,15.333 c3.635,8.159,7.27,16.319,10.905,24.478c0.842,1.89,1.684,3.78,2.526,5.67c0.392,0.88,1.685,0.118,1.295-0.757 c-2.277-5.111-4.554-10.222-6.831-15.333c-3.635-8.159-7.27-16.319-10.905-24.478c-0.842-1.89-1.684-3.78-2.526-5.67 C598.545,336.134,597.252,336.896,597.642,337.771L597.642,337.771z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M647.408,285.516c-1.686,2.477-4.622,3.418-6.558,2.1 c-1.936-1.317-2.138-4.394-0.451-6.871c1.686-2.477,4.622-3.418,6.558-2.1C648.892,279.962,649.094,283.038,647.408,285.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M648.645,298.91c0,1.309-1.062,2.371-2.371,2.371 c-1.309,0-2.371-1.061-2.371-2.371c0-1.31,1.062-2.371,2.371-2.371C647.584,296.539,648.645,297.6,648.645,298.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M665.835,360.059c0,2.544-2.063,4.607-4.607,4.607 c-2.544,0-4.607-2.063-4.607-4.607c0-2.544,2.063-4.607,4.607-4.607C663.772,355.452,665.835,357.515,665.835,360.059z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M328.636,453.428c1.309-4.718,1.345-9.97,1.932-14.43 c1.269-9.649,15.23-1.703,24.219-12.244c8.988-10.541-4.554-18.575,3.589-21.891c8.143-3.316,13.679-18.463,5.053-25.639 c-10.665-8.873-25.619-3.007-29.54,5.89c-3.025,6.863,1.305,13.266-14.537,14.89c-15.842,1.624-15.23,8.712-15.368,21.943 c-0.137,13.23-8.811,6.198-19.076,14.828c-5.818,4.891-4.218,11.727-1.74,16.733"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M297.31,454.378c7.79-9.001,15.604-17.981,23.453-26.93 c8.902-10.149,17.825-20.284,26.939-30.244c3.261-3.563,6.515-7.156,9.985-10.52c0.694-0.673-0.367-1.733-1.061-1.061 c-7.413,7.186-14.184,15.095-21.049,22.794c-9.275,10.404-18.459,20.89-27.611,31.401 c-3.913,4.493-7.818,8.993-11.717,13.498C295.62,454.044,296.677,455.11,297.31,454.378L297.31,454.378z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M331.997,414.21c5.811,1.162,11.622,2.325,17.432,3.487 c0.839,0.168,1.678,0.336,2.518,0.504c0.943,0.189,1.346-1.257,0.399-1.446c-5.811-1.162-11.622-2.325-17.432-3.487 c-0.839-0.168-1.678-0.336-2.518-0.504C331.453,412.575,331.049,414.02,331.997,414.21L331.997,414.21z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M310.985,404.725c1.745,7.376,3.49,14.752,5.235,22.127c0.25,1.055,0.499,2.109,0.749,3.164 c0.222,0.939,1.669,0.542,1.446-0.399c-1.745-7.376-3.49-14.752-5.235-22.127c-0.25-1.055-0.499-2.11-0.749-3.164 C312.209,403.388,310.762,403.785,310.985,404.725L310.985,404.725z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M346.179,386.005c-1.269,0.979-3.064,1.022-4.008,0.096 c-0.944-0.925-0.681-2.469,0.588-3.448c1.269-0.979,3.064-1.022,4.008-0.097C347.711,383.482,347.448,385.026,346.179,386.005z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M347.535,425.344c-0.313,1.253-1.746,1.974-3.201,1.61 c-1.455-0.364-2.38-1.674-2.067-2.927s1.746-1.973,3.201-1.61C346.923,422.781,347.849,424.091,347.535,425.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M87.33,452.495c-5.475,1.434-30.232,5.543-29.836-14.18 c0.202-10.073-2.734-9.707-8.637-13.654c-5.903-3.948-5.759-6.472-5.242-12.108c0.517-5.637-5.101-2.907-8.843-10.319 c-4.477-8.867,0.913-15.483,9.613-17.075c8.7-1.592,8.447,7.792,11.905,10.589s8.239-3.218,14.882,4.938 c4.337,5.324-2.397,17.471,3.983,16.339"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M75.923,434.935c-8.5-11.485-17.477-22.615-26.856-33.394 c-0.635-0.73-1.692,0.335-1.061,1.061c9.295,10.682,18.197,21.708,26.622,33.09 C75.196,436.46,76.498,435.712,75.923,434.935L75.923,434.935z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M61.48,401.024c-0.314,4.693-0.627,9.387-0.941,14.081 c-0.044,0.663-0.089,1.326-0.133,1.989c0.25-0.25,0.5-0.5,0.75-0.75c-4.306,0.357-8.612,0.713-12.918,1.07 c-0.955,0.079-0.964,1.58,0,1.5c4.306-0.357,8.612-0.713,12.918-1.07c0.425-0.035,0.721-0.316,0.75-0.75 c0.314-4.694,0.627-9.387,0.941-14.081c0.044-0.663,0.089-1.326,0.133-1.989C63.044,400.06,61.544,400.064,61.48,401.024 L61.48,401.024z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M48.666,335.858c-10.799-8.796-13.381-35.968,2.005-44.218 c19.023-10.201,38.937,5.587,41.442,21.822c1.933,12.523-6.826,21.268,15.967,30.448 c22.792,9.18,19.271,20.579,14.589,42.382c-4.682,21.802,10.721,13.809,22.691,32.212 c9.486,14.583-3.845,29.457-9.788,35.005l-46.62-0.227c-1.51-0.89-2.958-1.883-4.318-2.996 c-15.056-12.306-9.075-31.751-7.512-46.895c1.69-16.38-21.859-9.058-31.238-30.078 C36.503,352.293,59.465,344.654,48.666,335.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M127.391,452.81c-1.869-4.136-3.746-8.268-5.624-12.4 c-4.644-10.216-9.304-20.425-13.981-30.626c-5.967-13.013-11.96-26.014-18.001-38.993 c-5.832-12.53-11.699-25.044-17.685-37.501c-4.207-8.755-8.397-17.541-13.003-26.095c-0.354-0.658-0.712-1.313-1.077-1.965 c-0.471-0.843-1.767-0.087-1.295,0.757c4.391,7.858,8.264,16.021,12.181,24.121c5.886,12.171,11.638,24.406,17.355,36.658 c6.109,13.091,12.165,26.207,18.193,39.335c4.917,10.709,9.814,21.427,14.694,32.154c1.562,3.433,3.122,6.867,4.68,10.303 c0.716,1.578,1.327,3.285,2.174,4.799c0.037,0.066,0.064,0.141,0.095,0.211 C126.493,454.445,127.786,453.683,127.391,452.81L127.391,452.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M84.136,360.04c-9.028-0.479-18.056-0.958-27.084-1.436 c-1.282-0.068-2.564-0.136-3.846-0.204c-0.965-0.051-0.962,1.449,0,1.5c9.028,0.479,18.056,0.958,27.084,1.436 c1.282,0.068,2.564,0.136,3.846,0.204C85.101,361.591,85.098,360.091,84.136,360.04L84.136,360.04z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M115.367,427.578c-10.169-1.097-20.339-2.193-30.508-3.29 c-1.425-0.154-2.851-0.307-4.276-0.461c-0.959-0.103-0.951,1.397,0,1.5c10.169,1.097,20.339,2.193,30.508,3.29 c1.425,0.154,2.851,0.307,4.276,0.461C116.326,429.182,116.318,427.681,115.367,427.578L115.367,427.578z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M117.048,354.105c-2.045,4.401-4.09,8.803-6.136,13.204 c-3.262,7.019-6.523,14.038-9.785,21.057c-0.751,1.616-1.502,3.233-2.253,4.849c-0.404,0.87,0.888,1.633,1.295,0.757 c2.045-4.401,4.09-8.803,6.136-13.204c3.262-7.019,6.523-14.038,9.785-21.057c0.751-1.616,1.502-3.233,2.253-4.849 C118.747,353.992,117.455,353.23,117.048,354.105L117.048,354.105z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M73.637,309.874c1.513,2.13,4.146,2.939,5.882,1.806 c1.736-1.133,1.917-3.778,0.405-5.909c-1.513-2.13-4.146-2.939-5.882-1.806C72.306,305.099,72.125,307.744,73.637,309.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M72.528,321.392c0,1.126,0.952,2.039,2.127,2.039 c1.174,0,2.127-0.913,2.127-2.039c0-1.126-0.952-2.039-2.127-2.039C73.48,319.353,72.528,320.266,72.528,321.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M57.109,373.975c0,2.188,1.85,3.961,4.132,3.961 c2.282,0,4.132-1.774,4.132-3.961c0-2.188-1.85-3.961-4.132-3.961C58.959,370.014,57.109,371.787,57.109,373.975z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M154.602,453.355c0.933-0.55,1.828-1.164,2.669-1.851 c9.305-7.605,5.608-19.623,4.643-28.982c-1.044-10.123,13.509-5.598,19.306-18.589c5.797-12.991-8.394-17.712-1.72-23.148 c6.674-5.436,8.27-22.229-1.239-27.328c-11.757-6.304-24.064,3.453-25.612,13.486c-1.194,7.739,4.218,13.144-9.868,18.817 c-4.837,1.948-7.757,4.058-9.388,6.535"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M147.002,420.57c7.687-16.709,15.343-33.451,23.53-49.923 c1.366-2.749,2.739-5.498,4.235-8.179c0.471-0.844-0.824-1.601-1.295-0.757c-3.088,5.537-5.795,11.298-8.542,17.009 c-4.101,8.528-8.112,17.099-12.1,25.681c-2.385,5.133-4.758,10.271-7.123,15.412 C145.306,420.684,146.598,421.447,147.002,420.57L147.002,420.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M157.578,396.943c5.57-0.295,11.14-0.591,16.71-0.886c0.802-0.043,1.604-0.085,2.406-0.128 c0.96-0.051,0.966-1.551,0-1.5c-5.57,0.295-11.14,0.591-16.71,0.886c-0.802,0.043-1.604,0.085-2.406,0.128 C156.618,395.494,156.612,396.995,157.578,396.943L157.578,396.943z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M147.252,437.716c3.649-0.393,7.297-0.787,10.946-1.18c0.525-0.057,1.05-0.113,1.576-0.17 c0.95-0.102,0.96-1.603,0-1.5c-3.649,0.393-7.297,0.787-10.946,1.18c-0.525,0.057-1.05,0.113-1.576,0.17 C146.303,436.318,146.292,437.819,147.252,437.716L147.252,437.716z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M136.19,392.674c3.281,7.06,6.561,14.119,9.841,21.179c0.464,0.997,0.927,1.995,1.391,2.992 c0.406,0.875,1.7,0.114,1.295-0.757c-3.281-7.06-6.561-14.119-9.842-21.179c-0.464-0.997-0.927-1.995-1.391-2.992 C137.079,391.043,135.786,391.803,136.19,392.674L136.19,392.674z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M164.067,364.726c-0.935,1.316-2.562,1.816-3.635,1.116 c-1.073-0.7-1.185-2.335-0.25-3.652c0.935-1.316,2.562-1.816,3.635-1.116C164.889,361.774,165.001,363.409,164.067,364.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M174.282,404.342c0,1.352-1.143,2.448-2.554,2.448 c-1.411,0-2.554-1.096-2.554-2.448c0-1.352,1.143-2.448,2.554-2.448C173.138,401.893,174.282,402.99,174.282,404.342z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.368,
    y: 113.951,
    style: {
      fill: "#92CDFE"
    },
    width: 13.394,
    height: 88.025
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.639,
    y: 130.256,
    style: {
      fill: "#92CDFE"
    },
    width: 13.395,
    height: 71.721
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.732,
    y: 140.913,
    style: {
      fill: "#6FBBEF"
    },
    width: 13.394,
    height: 61.064
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.003,
    y: 120.833,
    style: {
      fill: "#6FBBEF"
    },
    width: 13.394,
    height: 81.144
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.274,
    y: 139.161,
    style: {
      fill: "#6FBBEF"
    },
    width: 13.395,
    height: 62.815
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.91,
    y: 112.189,
    style: {
      fill: "#92CDFE"
    },
    width: 13.395,
    height: 89.787
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M348.948,120.829 c-19.528,1.574-34.889,17.908-34.889,37.842c0,19.934,15.361,36.268,34.889,37.842V120.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FBBEF",
      stroke: "#6FBBEF",
      strokeMiterlimit: 10
    },
    d: "M353.404,120.728v75.886 c20.34-0.721,36.611-17.427,36.611-37.943C390.014,138.155,373.744,121.449,353.404,120.728z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 197.482,
    y1: 214.04,
    x2: 269.382,
    y2: 214.04
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 204.965,
    y1: 221.205,
    x2: 260.329,
    y2: 221.205
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 318.457,
    y1: 220.826,
    x2: 378.548,
    y2: 220.826
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 310.467,
    y1: 230.157,
    x2: 376.125,
    y2: 230.157
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 310.467,
    y1: 239.487,
    x2: 370.498,
    y2: 239.487
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 310.467,
    y1: 248.818,
    x2: 374.426,
    y2: 248.818
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M413.139,70.351h-250.97c-1.656,0-2.998-1.342-2.998-2.998l0,0c0-1.656,1.342-2.998,2.998-2.998 h250.97c1.656,0,2.998,1.342,2.998,2.998l0,0C416.137,69.008,414.794,70.351,413.139,70.351z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.136,
    y: 70.351,
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    width: 240.103,
    height: 186.992
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M413.139,262.799h-250.97c-1.656,0-2.998-1.342-2.998-2.998v0c0-1.656,1.342-2.998,2.998-2.998 h250.97c1.656,0,2.998,1.342,2.998,2.998v0C416.137,261.457,414.794,262.799,413.139,262.799z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M306.93,55.565h36.633c4.68,0,8.475,3.606,8.475,8.055 v14.215v4.972v15.574l-8.616-7.519H306.93c-4.68,0-8.474-3.606-8.474-8.055V63.62 C298.455,59.171,302.249,55.565,306.93,55.565z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M333.629,73.853c0,1.934,1.65,3.502,3.685,3.502c2.035,0,3.685-1.568,3.685-3.502 c0-1.934-1.65-3.502-3.685-3.502C335.278,70.351,333.629,71.919,333.629,73.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M320.811,73.853c0,1.934,1.65,3.502,3.685,3.502c2.035,0,3.685-1.568,3.685-3.502 c0-1.934-1.65-3.502-3.685-3.502C322.461,70.351,320.811,71.919,320.811,73.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M307.994,73.853c0,1.934,1.65,3.502,3.685,3.502c2.035,0,3.685-1.568,3.685-3.502 c0-1.934-1.65-3.502-3.685-3.502C309.644,70.351,307.994,71.919,307.994,73.853z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A66957"
    },
    d: "M285.816,116.576c0,0-7.012-9.409-6.555-12.212c0.457-2.803,3.583-1.904,5.206,0.151 c1.623,2.055,6.944,9.142,7.042,9.726C291.606,114.826,285.816,116.576,285.816,116.576z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A66957"
    },
    d: "M298.915,116.912c-3.029-3.249-5.526-5.848-7.789-5.007c-1.188,0.441-3.3,1.817-4.763,3.422 c-0.412-0.3-0.806-0.527-1.152-0.63c-2.057-0.615-3.771,0.631-3.627,3.108c-1.187-0.43-3.29,0.557-2.457,3.5l-0.271-0.33 c-0.907-0.378-3.535,0.857-2.376,3.825c1.159,2.967,4.675,5.258,6.229,4.788c0.293-0.089,0.514-0.225,0.705-0.377 l-0.036,0.045l17.17,17.286l12.105-11.668C312.654,134.874,301.944,120.161,298.915,116.912z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7F4040",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M311.901,133.228 c-2.476-3.159-4.951-6.317-7.427-9.475c-2.93-3.738-5.882-7.5-9.448-10.638c-0.712-0.626-1.522-1.256-2.469-1.286 c-0.511-0.016-1.01,0.147-1.492,0.32c-1.511,0.543-3.016,1.222-4.165,2.344c-1.149,1.122-1.893,2.764-1.592,4.341 c0.108,0.568,0.381,1.147,0.889,1.421c0.601,0.324,1.341,0.139,1.986-0.087c1.577-0.553,3.083-1.309,4.469-2.243"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7F4040",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M290.544,120.196 c0.805,1.057,0.378,2.813-0.824,3.382c-0.715,0.339-1.572,0.273-2.308-0.02c-0.735-0.292-1.369-0.791-1.963-1.314 c-1.642-1.445-3.1-3.168-3.884-5.211"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7F4040",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M287.675,124.395 c-0.303,1.159-0.781,2.464-1.907,2.87c-0.646,0.233-1.382,0.099-1.989-0.223c-0.607-0.321-1.105-0.814-1.568-1.322 c-1.358-1.494-2.489-3.196-3.34-5.027"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7F4040",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M284.289,127.945 c-0.092,1.103-1.221,2.004-2.317,1.85c-0.515-0.072-0.982-0.338-1.416-0.626c-1.825-1.214-3.308-2.936-4.237-4.921"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#6FBBEF",
      strokeMiterlimit: 10
    },
    points: "301.391,163.632 291.974,150.71  312.654,131.731 322.837,145.418  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M390.698,133.228l-47.166,27.195l-25.418-25.114l-26.604,23.949 c0,0,27.116,41.041,42.018,50.203c14.672,9.021,35.567,0.734,47.966-16.186C393.893,176.355,390.698,133.228,390.698,133.228 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M347.802,164.643l-29.689-29.334 l-26.604,23.949c0,0,27.116,41.041,42.018,50.203c14.672,9.021,35.567,0.734,47.966-16.186"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A66957"
    },
    points: "368.43,396.85 363.845,421.851 379.799,426.882 386.299,398.981  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#16004D"
    },
    points: "325.691,452.849 384.509,452.57 386.697,418.225 358.415,419.556  354.664,433.365  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.341,438.398c1.065,2.346,2.131,4.693,3.196,7.039 c0.152,0.336,0.305,0.672,0.457,1.007c0.139,0.306,0.586,0.384,0.855,0.224c0.315-0.186,0.365-0.545,0.224-0.855 c-1.065-2.346-2.131-4.693-3.196-7.039c-0.152-0.336-0.305-0.672-0.457-1.007c-0.139-0.306-0.586-0.383-0.855-0.224 C342.25,437.729,342.201,438.088,342.341,438.398L342.341,438.398z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.74,435.419c1.065,2.346,2.131,4.693,3.196,7.039 c0.152,0.336,0.305,0.672,0.457,1.007c0.139,0.306,0.586,0.383,0.855,0.224c0.315-0.186,0.365-0.545,0.224-0.855 c-1.065-2.346-2.131-4.693-3.196-7.039c-0.152-0.336-0.305-0.671-0.457-1.007c-0.139-0.306-0.586-0.383-0.855-0.224 C347.649,434.75,347.6,435.109,347.74,435.419L347.74,435.419z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A66957"
    },
    points: "456.706,396.85 461.292,421.851 445.338,426.882 438.837,398.981  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#16004D"
    },
    points: "499.445,452.849 440.627,452.57 438.44,418.225 466.36,418.225 470.472,433.365  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M481.716,437.767c-1.065,2.346-2.131,4.693-3.196,7.039 c-0.152,0.336-0.305,0.672-0.457,1.007c-0.141,0.309-0.086,0.669,0.224,0.855c0.267,0.16,0.716,0.082,0.855-0.224 c1.065-2.346,2.131-4.693,3.196-7.039c0.152-0.336,0.305-0.672,0.457-1.007c0.14-0.31,0.086-0.669-0.224-0.855 C482.304,437.383,481.855,437.46,481.716,437.767L481.716,437.767z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M476.317,434.788c-1.065,2.346-2.131,4.693-3.196,7.039 c-0.152,0.336-0.305,0.671-0.457,1.007c-0.141,0.31-0.086,0.669,0.224,0.855c0.267,0.16,0.716,0.083,0.855-0.224 c1.065-2.346,2.131-4.693,3.196-7.039c0.152-0.336,0.305-0.672,0.457-1.007c0.141-0.31,0.086-0.669-0.224-0.855 C476.905,434.404,476.456,434.481,476.317,434.788L476.317,434.788z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2E4ECC"
    },
    points: "408.139,275.476 393.514,436.426 346.534,433.473 373.899,220.513 405.626,224.829  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#161522",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "405.626,224.829  408.139,275.476 393.831,436.446 346.534,433.473  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#2E4ECC"
    },
    points: "396.025,260.365 406.641,260.365 426.978,433.785 471.831,431.785  443.897,221.438 394.472,221.438  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#161522",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "403.277,260.365  406.641,260.365 426.978,433.785 471.004,431.822  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M396.776,164.645c0,0-2.154-18.058-1.256-23.297c0.897-5.239,3.769-11.341,8.346-11.611 c4.577-0.269,16.063,0.09,18.217,3.051s6.371,6.999,4.846,17.589c-1.525,10.589-8.076,49.327-8.076,49.327l-4.689,11.336 h-8.316L396.776,164.645z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeMiterlimit: 10
    },
    x1: 409.067,
    y1: 127.381,
    x2: 409.067,
    y2: 195.892
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#6FBBEF",
      strokeMiterlimit: 10
    },
    d: "M401.204,125.701l-5.455,5.226l5.326,13.233 l8.031-12.015l7.116,12.015l7.262-13.233l-5.966-6.261C417.518,124.666,413.512,131.589,401.204,125.701z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A66957"
    },
    d: "M417.336,108.475V97.153c0-6.5-4.671-11.818-10.381-11.818h-8.587 c-5.709,0-10.381,5.318-10.381,11.818v13.312c0,6.5,4.671,11.819,10.381,11.819h2.751v5.56c0,2.804,2.273,5.077,5.077,5.077 h6.16c2.804,0,5.077-2.273,5.077-5.077v-4.684v-1.809V120.9v-8.104v-3.359C417.433,109.108,417.396,108.788,417.336,108.475z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M416.137,103.794c0,0-1.942-11.215-2.465-9.559c-0.746,2.363-0.657,15.447-3.195,16.597 c-3.359,1.522-4.594-4.225-11.359-4.456c-6.765-0.231-10.654,3.095-11.311,5.803c-0.657,2.708,2.827,6.569,4.952,8.342 c2.664,2.224,10.394,1.761,10.394,1.761s6.695,0.406,9.495-3.545C415.561,114.628,416.137,103.794,416.137,103.794z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M404.99,101.503c0,1.069-0.866,1.936-1.936,1.936c-1.069,0-1.936-0.867-1.936-1.936 c0-1.069,0.867-1.936,1.936-1.936C404.123,99.567,404.99,100.434,404.99,101.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M392.317,101.219c0,0.913-0.74,1.652-1.652,1.652c-0.913,0-1.652-0.74-1.652-1.652 c0-0.912,0.74-1.652,1.652-1.652C391.577,99.567,392.317,100.307,392.317,101.219z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M402.398,98.098c0.229,0.002,0.458,0.013,0.686,0.036c0.049,0.005,0.098,0.011,0.146,0.016 c0.119,0.014-0.047-0.009,0.062,0.009c0.113,0.019,0.226,0.037,0.338,0.06c0.434,0.087,0.857,0.216,1.267,0.382 c0.243,0.098,0.56-0.107,0.615-0.349c0.066-0.289-0.089-0.51-0.349-0.615c-0.876-0.353-1.821-0.532-2.766-0.538 c-0.262-0.002-0.512,0.231-0.5,0.5C401.911,97.87,402.118,98.096,402.398,98.098L402.398,98.098z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M389.802,98.424c0.149-0.089,0.302-0.171,0.459-0.246c0.042-0.02,0.084-0.039,0.126-0.058 c0.029-0.013,0.126-0.064,0.008-0.005c0.077-0.038,0.162-0.065,0.243-0.095c0.321-0.117,0.652-0.203,0.989-0.26 c0.259-0.044,0.427-0.376,0.349-0.615c-0.09-0.279-0.338-0.396-0.615-0.349c-0.726,0.124-1.431,0.389-2.064,0.765 c-0.225,0.133-0.326,0.456-0.179,0.684C389.264,98.471,389.561,98.567,389.802,98.424L389.802,98.424z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M395.802,99.863c-0.854,1.405-1.605,2.869-2.249,4.382 c-0.067,0.157-0.016,0.306,0.149,0.367c0.75,0.278,1.499,0.556,2.249,0.834c0.302,0.112,0.432-0.371,0.133-0.482 c-0.75-0.278-1.499-0.556-2.249-0.834c0.05,0.122,0.1,0.245,0.149,0.367c0.643-1.513,1.395-2.977,2.249-4.382 C396.402,99.84,395.97,99.588,395.802,99.863L395.802,99.863z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M394.894,111.095c0,0,2.896-0.291,5.747-1.83c0,0,0.367,2.904-1.821,3.546 C395.846,113.683,394.894,111.095,394.894,111.095z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M414.904,106.158l-1.585-10.427c0,0-28.848,3.616-38.2-10.397 c-9.352-14.013,0.475-19.561,5.231-18.768c4.755,0.793,10.315,7.608,10.315,7.608s-4.426-6.023,0-6.974 c4.426-0.951,9.315,3.646,11.864,8.401c0,0,19.015-1.773,25.443,9.733c6.428,11.506,1.218,19.669-10.539,31.557l-1.072-6.649 L414.904,106.158z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A66957"
    },
    d: "M427.971,106.377c0,3.745-3.061,6.781-6.837,6.781c-3.776,0-6.837-3.036-6.837-6.781 c0-3.745,3.061-6.781,6.837-6.781C424.91,99.595,427.971,102.632,427.971,106.377z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4040"
    },
    d: "M417.849,107.272c-0.009-0.146-0.004-0.294,0.004-0.44c0.004-0.068,0.009-0.136,0.016-0.204 c0.004-0.038,0.008-0.075,0.012-0.113c0.016-0.144-0.011,0.052,0.008-0.059c0.031-0.189,0.066-0.376,0.114-0.561 c0.025-0.096,0.054-0.192,0.085-0.286c0.018-0.054,0.037-0.107,0.057-0.16c0.011-0.029,0.077-0.185,0.035-0.091 c0.098-0.221,0.212-0.433,0.35-0.631c0.017-0.024,0.114-0.151,0.058-0.081c0.036-0.045,0.073-0.089,0.112-0.132 c0.087-0.097,0.18-0.189,0.278-0.275c0.02-0.018,0.15-0.119,0.088-0.074c0.05-0.037,0.102-0.073,0.154-0.108 c0.121-0.079,0.248-0.148,0.378-0.21c0.082-0.039,0.061-0.03,0.171-0.07c0.082-0.03,0.165-0.057,0.249-0.081 c0.157-0.045,0.368-0.09,0.493-0.107c0.447-0.062,0.906-0.046,1.354,0c0.222,0.023,0.413-0.206,0.413-0.413 c0-0.242-0.19-0.39-0.413-0.413c-1.395-0.145-2.909,0.135-3.839,1.271c-0.612,0.748-0.904,1.683-0.987,2.635 c-0.017,0.199-0.029,0.402-0.016,0.602C417.057,107.8,417.883,107.804,417.849,107.272L417.849,107.272z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M421.505,128.381l33.973,20.301l0.94,48.88l6.258,80.297c0,0-7.376,4.514-20.744,2.893 c-4.309-0.522-8.847-0.975-14.476-3.346c-23.091-9.726-19.146-22.614-19.146-22.614l0.057-72.928 C408.368,181.863,425.716,142.403,421.505,128.381z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M407.736,204.961l0.632,54.721 c0,0,2.212,14.081,25.071,19.484c22.859,5.403,29.238-1.307,29.238-1.307s-7.869-93.322-7.014-98.139"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M454.111,245.25 c-6.176-2.911-12.232-6.023-18.151-9.328"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M431.568,140.165 c6.479,12.171,7.585,17.541,7.585,17.541h-12.308l6.409,14.14l-24.886,33.114"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M397.611,128.381l-31.137,20.301v48.087l-6.597,81.09c0,0,6.047,4.601,18.277,2.994 c3.957-0.52,8.829-1.069,14.002-3.447c21.163-9.726,17.547-22.614,17.547-22.614l-0.052-72.928 C409.652,181.863,393.752,142.403,397.611,128.381z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M405.965,206.639c0,1.134-0.857,2.054-1.915,2.054 c-1.058,0-1.915-0.92-1.915-2.054c0-1.134,0.857-2.054,1.915-2.054C405.108,204.585,405.965,205.505,405.965,206.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M405.965,221.758c0,1.134-0.857,2.054-1.915,2.054 c-1.058,0-1.915-0.92-1.915-2.054c0-1.134,0.857-2.054,1.915-2.054C405.108,219.704,405.965,220.623,405.965,221.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M405.965,236.876c0,1.134-0.857,2.054-1.915,2.054 c-1.058,0-1.915-0.92-1.915-2.054c0-1.134,0.857-2.054,1.915-2.054C405.108,234.822,405.965,235.742,405.965,236.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M366.251,193.921 c0.784,4.817-6.374,83.937-6.374,83.937s5.847,6.71,26.797,1.307c20.95-5.403,22.978-19.484,22.978-19.484l-0.59-79.439"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M367.319,245.249 c5.661-2.91,11.211-6.023,16.636-9.328"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M388.388,140.165 c-5.938,12.172-6.952,17.541-6.952,17.541h11.28l-5.874,14.14l22.391,31.576"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A66957"
    },
    d: "M401.602,195.452c0,0-5.613-5.007-4.828-6.618c1.193-2.447,10.194,3.917,12.247,4.866 c2.053,0.949,8.106,5.059,10.536,6.8c2.43,1.741,7.457,3.98,7.457,3.98l-2.598,14.421c0,0-18.133-2.271-27.341-4.853 c-9.208-2.583-16.541-6.685-16.077-8.872c0.464-2.188,2.818-0.302,2.818-0.302s-3.807-2.434-3.483-3.751 c0.324-1.318,3.685-0.266,3.685-0.266s-4.729-2.464-4.219-4.277c0.51-1.813,6.623,0.96,6.623,0.96s-4.68-2.921-3.675-4.424 c1.005-1.503,9.138,1.835,14.861,4.132C403.329,199.543,403.19,196.977,401.602,195.452z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4040"
    },
    d: "M382.63,204.633c2.595,1.534,5.408,2.675,8.338,3.38c0.469,0.113,0.669-0.61,0.199-0.723 c-2.872-0.691-5.616-1.801-8.159-3.305C382.592,203.739,382.214,204.387,382.63,204.633L382.63,204.633z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4040"
    },
    d: "M382.172,199.954c2.87,1.495,5.847,2.779,8.903,3.842c0.457,0.159,0.653-0.565,0.199-0.723 c-2.996-1.042-5.91-2.301-8.724-3.767C382.123,199.084,381.743,199.731,382.172,199.954L382.172,199.954z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4040"
    },
    d: "M384.499,196.783c2.825,1.141,5.65,2.282,8.475,3.423c0.447,0.181,0.642-0.544,0.199-0.723 c-2.825-1.141-5.65-2.282-8.475-3.423C384.251,195.879,384.057,196.604,384.499,196.783L384.499,196.783z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#6FBBEF",
      strokeMiterlimit: 10
    },
    points: "431.106,225.259 415.705,220.963 420.69,194.046  436.632,197.67  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M500.436,203.038c3.371-40.005-76.216-73.035-76.216-73.035l24.958,52.995l9.027,7.19 l10.997-0.161l-44.594,0.655l-7.46,33.839C471.748,251.25,499.145,218.358,500.436,203.038z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M500.436,203.038 c-1.291,15.32-28.688,48.212-83.288,21.483l7.46-33.839l44.594-0.655"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 458.205,
    y1: 190.188,
    x2: 449.178,
    y2: 182.998
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M481.164,147.898h36.78c4.699,0,8.508,3.621,8.508,8.087 v14.272v4.992v15.637l-8.651-7.549h-36.637c-4.699,0-8.508-3.621-8.508-8.087v-19.264 C472.656,151.518,476.465,147.898,481.164,147.898z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9999 0.0112 -0.0112 0.9999 491.1419 177.6186)",
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10,
      fontFamily: "'Quicksand-Bold'",
      fontSize: "35.5487px"
    }
  }, "?")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M517.689,113.508h23.828c3.044,0,5.512,2.346,5.512,5.24 v9.246v3.234v10.13l-5.604-4.891h-23.736c-3.044,0-5.512-2.346-5.512-5.239v-12.48 C512.177,115.853,514.645,113.508,517.689,113.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M522.447,124.948c0,1.113-0.902,2.016-2.016,2.016c-1.113,0-2.016-0.903-2.016-2.016 s0.902-2.016,2.016-2.016C521.544,122.932,522.447,123.835,522.447,124.948z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#92CDFE"
    },
    cx: 528.558,
    cy: 124.948,
    r: 2.016
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92CDFE"
    },
    d: "M538.701,124.948c0,1.113-0.902,2.016-2.016,2.016c-1.113,0-2.016-0.903-2.016-2.016 s0.902-2.016,2.016-2.016C537.799,122.932,538.701,123.835,538.701,124.948z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M574.224,245.885l50.028,0.262 c5.473,0.029,9.775,4.689,9.367,10.146l-7.49,100.229c-0.374,5.005-4.599,8.844-9.617,8.737l-114.177-2.429 c-5.472-0.116-9.699-4.845-9.203-10.296l0,0c0.442-4.864,4.52-8.588,9.404-8.588l46.703-1.128 c5.359,0,14.339-3.22,14.13-8.575l1.37-78.549C564.529,250.32,568.845,245.857,574.224,245.885z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 619.387,
    y1: 256.853,
    x2: 607.903,
    y2: 341.564
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M559.983,340.925 c0.134-0.157,32.971,0,32.971,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 569.941,
    y: 352.163,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1149.1467 764.4752)",
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    width: 9.265,
    height: 60.15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M571.727,431.517h5.693c2.37,0,4.29-1.921,4.29-4.29v-42.793c0-2.369-1.921-4.29-4.29-4.29 h-5.693c-2.37,0-4.29,1.921-4.29,4.29v42.793C567.437,429.596,569.358,431.517,571.727,431.517z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2E4ECC"
    },
    points: "538.014,427.215 540.288,427.215 608.859,427.215 614.25,427.215 614.25,433.398  614.25,440.355 608.859,440.355 608.859,433.398 540.288,433.398 540.288,440.355 534.896,440.355 534.896,433.398  534.896,427.215  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M529.272,443.907c0,4.567,3.702,8.27,8.269,8.27 c4.567,0,8.269-3.702,8.269-8.27c0-4.567-3.702-8.269-8.269-8.269C532.974,435.638,529.272,439.34,529.272,443.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M534.373,443.907c0,1.75,1.419,3.169,3.169,3.169s3.169-1.419,3.169-3.169 c0-1.75-1.419-3.169-3.169-3.169S534.373,442.158,534.373,443.907z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M603.571,443.907c0,4.567,3.702,8.27,8.269,8.27 c4.567,0,8.269-3.702,8.269-8.27c0-4.567-3.702-8.269-8.269-8.269C607.273,435.638,603.571,439.34,603.571,443.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M608.672,443.907c0,1.75,1.419,3.169,3.169,3.169c1.75,0,3.168-1.419,3.168-3.169 c0-1.75-1.419-3.169-3.168-3.169C610.09,440.739,608.672,442.158,608.672,443.907z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C8A6"
    },
    points: "449.8,390.83 444.353,426.035 468.859,426.035 471.831,390.83  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "405.327,453.153 473.792,453.848 472.454,420.208 442.08,421.439  438.052,434.207  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M424.857,438.884c1.145,2.171,2.29,4.342,3.435,6.513 c0.163,0.309,0.326,0.618,0.489,0.926c0.375,0.712,1.455,0.081,1.079-0.631c-1.145-2.171-2.29-4.342-3.435-6.513 c-0.163-0.309-0.326-0.618-0.489-0.926C425.561,437.541,424.481,438.172,424.857,438.884L424.857,438.884z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M430.655,436.13c1.145,2.171,2.29,4.342,3.435,6.513 c0.163,0.309,0.326,0.618,0.489,0.927c0.375,0.712,1.455,0.081,1.079-0.631c-1.145-2.171-2.29-4.342-3.435-6.513 c-0.163-0.309-0.326-0.618-0.489-0.927C431.359,434.787,430.28,435.418,430.655,436.13L430.655,436.13z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M527.813,293.666c0,0-52.089-1.178-66.836,13.645c-9.28,9.327-22.597,93.888-22.597,93.888 h48.695l7.957-80.203l49.634-5.171L527.813,293.666z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 438.381,
    y1: 401.198,
    x2: 487.075,
    y2: 401.198
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C8A6"
    },
    points: "488.826,392.009 488.826,427.213 513.332,427.213 513.491,392.009  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "449.8,453.153 518.265,453.848 516.927,420.208 486.552,421.439 482.524,434.207  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "486.552,421.439  482.524,434.207 449.8,453.153  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M469.329,438.884c1.145,2.171,2.29,4.342,3.435,6.513 c0.163,0.309,0.326,0.618,0.489,0.926c0.375,0.712,1.455,0.081,1.079-0.631c-1.145-2.171-2.29-4.342-3.435-6.513 c-0.163-0.309-0.326-0.618-0.489-0.926C470.033,437.541,468.954,438.172,469.329,438.884L469.329,438.884z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M475.128,436.13c1.145,2.171,2.29,4.342,3.435,6.513 c0.163,0.309,0.326,0.618,0.489,0.927c0.375,0.712,1.455,0.081,1.079-0.631c-1.145-2.171-2.29-4.342-3.435-6.513 c-0.163-0.309-0.326-0.618-0.489-0.927C475.832,434.787,474.752,435.418,475.128,436.13L475.128,436.13z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M588.202,299.354H547.26c-50.305-3.584-70.264,8.543-70.264,27.371 c0,12.731,2.579,79.965,2.579,79.965l44.686-1.317l-2.89-61.039c0,0,32.221,4.351,52.271-1.388 C593.694,337.208,588.202,299.354,588.202,299.354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M583.046,335.935 c-2.233,3.29-5.277,5.83-9.403,7.011c-20.051,5.738-52.271,1.388-52.271,1.388"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M524.261,405.373l-44.686,1.317 c0,0-2.579-67.235-2.579-79.965c0-18.828,19.959-30.954,70.264-27.371"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 520.974,
    y1: 335.934,
    x2: 522.008,
    y2: 357.778
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M496.179,202.716c-2.296-3.92-3.441-5.797-4.72-5.206c-1.279,0.591-1.184,3.073-1.184,3.073 c-5.392-6.427-9.377-8.783-10.306-7.408c-0.294,0.435-0.148,1.008,0.188,1.587c-1.069-0.949-2.242-1.418-2.784-0.72 c-0.653,0.842-0.124,1.738,0.154,2.281c-1.393-1.248-2.914-1.715-3.389-0.3c-0.426,1.269,0.362,2.404,1.069,3.117 c-1.555-1.091-2.371-0.405-2.539,0.762c-0.199,1.379,2.07,4.582,6.904,10.667c4.834,6.085,13.816,18.85,13.816,18.85 l12.349-10.479C505.737,218.941,498.474,206.636,496.179,202.716z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M490.174,211.96 c0,0-0.179-3.711,0.388-5.073c0.566-1.362-1.033-7.763,0.347-9.127c1.38-1.364,2.985,0.837,3.997,2.727 c1.012,1.89,10.107,17.204,10.107,17.204"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 474.469,
    y1: 198.684,
    x2: 481.062,
    y2: 205.115
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 476.659,
    y1: 195.717,
    x2: 483.308,
    y2: 202.956
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 479.888,
    y1: 194.235,
    x2: 485.548,
    y2: 200.888
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#6FBBEF",
      strokeMiterlimit: 10
    },
    d: "M495.142,235.805l16.496-15.52l-5.435-4.385 l-14.05,13.225C492.152,229.125,493.264,231.885,495.142,235.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M545.338,244.21l-34.001-26.034l-17.771,16.727c0,0,2.535,6.3,6.557,14.001 c5.307,10.161,13.388,22.39,21.28,26.55c18.584,9.797,36.082,4.741,47.633-0.967 C580.586,268.78,545.338,244.21,545.338,244.21z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#16004D",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 545.338,244.21 511.337,218.176 493.567,234.903  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M568.233,207.999c-19.945,2.656-29.812,40.791-29.812,40.791l-13.154,44.854 c0,0,6.316,12.115,27.06,17.003c24.983,5.886,43.276-3.415,43.276-3.415v-58.572l-16.643-40.66L568.233,207.999z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#16004D",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M595.813,282.366l-0.21,24.865 c0,0-12.289,6.468-33.259,5.367c-20.969-1.1-35.327-14.16-38.192-20.684"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#16004D",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M532.481,264.862c0,0,9.537-29.946,14.667-37.954"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M635.703,266.683c-16.895-49.273-56.743-58.684-56.743-58.684l-6.272,1.777l10.919,35.261 l9.346,18.504l-0.941-0.027l-40.717-1.184l-1.702,26.196C549.593,288.525,652.945,316.968,635.703,266.683z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#16004D",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M635.703,266.683 c17.242,50.286-86.11,21.842-86.11,21.842l1.702-26.196l40.717,1.184l6.251,0.182"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#16004D",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 583.607,
    y1: 245.037,
    x2: 592.954,
    y2: 263.541
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M560.955,165.766l8.233,0.133c5.474,0.088,9.87,5.259,9.77,11.492l-0.206,12.763 c-0.006,0.36-0.03,0.714-0.065,1.065c0.083,0.378,0.128,0.769,0.122,1.171l-0.125,7.77l-0.007,0.433l-0.125,7.769 c-0.045,2.82-2.389,5.089-5.208,5.044l-3.266-0.053c-2.819-0.046-5.089-2.389-5.043-5.209l0.111-6.875l-4.761-0.077 c-5.474-0.088-9.87-5.259-9.77-11.492l0.206-12.763C550.921,170.704,555.482,165.678,560.955,165.766z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M583.267,190.42c0,0,7.564-4.979,8.741-13.531c0,0,0.525-13.072-10.357-18.083 c-10.882-5.011-21.711-3.247-26.07-1.685c-8.175,2.929-11.695,7.693-8.666,14.399 c2.254,4.989,13.938,2.579,18.016-0.446c0,0,0.629,5.241,10.639,6.866l3.212,13.857l0.139,4.521L583.267,190.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M567.229,181.372c-0.017,1.025-0.861,1.843-1.886,1.826 c-1.025-0.017-1.842-0.861-1.826-1.886c0.016-1.025,0.861-1.842,1.886-1.826 C566.428,179.503,567.246,180.347,567.229,181.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M555.083,180.904c-0.014,0.875-0.735,1.573-1.61,1.559 c-0.875-0.014-1.573-0.735-1.559-1.61c0.014-0.875,0.735-1.573,1.61-1.558 C554.399,179.309,555.097,180.029,555.083,180.904z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M556.733,188.527c0,0,0.889,2.733,2.858,2.951c1.969,0.218,3.549-1.942,3.684-3.646 L556.733,188.527z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8576"
    },
    d: "M573.299,188.031c-0.059,2.385-2.041,4.271-4.426,4.211 c-2.385-0.059-4.271-2.04-4.211-4.426c0.059-2.385,2.041-4.27,4.426-4.211 C571.473,183.665,573.359,185.646,573.299,188.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8576"
    },
    d: "M551.495,184.591c-0.263-0.006-0.518,0.021-0.765,0.074l-0.111,4.479 c-0.016,0.669-0.008,1.317,0.112,1.951c0.18,0.035,0.411,0.066,0.6,0.07c1.815,0.045,3.323-1.39,3.369-3.206 C554.746,186.144,553.31,184.636,551.495,184.591z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB3341",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M572.942,180.778 c-0.061,3.761-2.663,6.77-5.811,6.719c-3.149-0.051-5.653-3.141-5.592-6.902c0.061-3.762,2.663-6.77,5.812-6.719 C570.499,173.926,573.003,177.016,572.942,180.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EB3341",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M558.062,179.887 c-0.057,3.527-2.376,6.348-5.181,6.303c-2.805-0.045-5.032-2.94-4.975-6.467c0.057-3.526,2.377-6.348,5.181-6.303 C555.891,173.465,558.119,176.361,558.062,179.887z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EB3341",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 572.942,
    y1: 180.778,
    x2: 580.283,
    y2: 182.593
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010001"
    },
    d: "M559.354,178.27c-0.491,1.958-1.392,3.795-2.663,5.366 c-0.17,0.21-0.159,0.495,0.084,0.648c0.896,0.569,1.793,1.137,2.689,1.706c0.45,0.285,0.865-0.429,0.417-0.713 c-0.896-0.569-1.793-1.137-2.689-1.706c0.028,0.216,0.056,0.432,0.084,0.648c1.362-1.684,2.347-3.628,2.875-5.73 C560.28,177.974,559.484,177.754,559.354,178.27L559.354,178.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB3341"
    },
    d: "M561.331,181.678c-1.989-1.131-3.736-0.145-3.79-0.103l0.058-0.722 c0.072-0.06,1.631-1.422,4.182,0.03L561.331,181.678z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M552.381,178.183c0.911-0.266,1.818-0.545,2.721-0.836 c0.311-0.1,0.544-0.438,0.437-0.769c-0.101-0.311-0.436-0.544-0.769-0.437c-0.903,0.291-1.81,0.57-2.721,0.836 c-0.314,0.092-0.542,0.444-0.437,0.769C551.716,178.065,552.045,178.281,552.381,178.183L552.381,178.183z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M565.035,177.103c1.51,0.621,3.052,1.16,4.619,1.615 c0.324,0.094,0.68-0.114,0.769-0.437c0.091-0.33-0.111-0.674-0.437-0.769c-1.568-0.455-3.109-0.994-4.619-1.615 c-0.312-0.128-0.687,0.139-0.769,0.437C564.5,176.693,564.722,176.974,565.035,177.103L565.035,177.103z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M589.188,186.4c-0.058,3.591-3.039,6.454-6.66,6.396c-3.62-0.058-6.508-3.017-6.45-6.607 c0.058-3.591,3.039-6.454,6.66-6.396C586.358,179.851,589.246,182.809,589.188,186.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8576"
    },
    d: "M579.487,187.096c-0.007-0.138,0.001-0.277,0.01-0.414 c0.005-0.066,0.011-0.132,0.018-0.197c0.004-0.036,0.009-0.073,0.013-0.109c-0.018,0.15,0.004-0.02,0.009-0.053 c0.03-0.183,0.07-0.364,0.12-0.543c0.026-0.093,0.055-0.186,0.088-0.277c0.017-0.047,0.035-0.094,0.053-0.141 c0.002-0.005,0.04-0.097,0.014-0.035c-0.025,0.058,0.024-0.053,0.029-0.064c0.094-0.204,0.207-0.396,0.335-0.58 c0.066-0.095-0.018,0.014,0.056-0.074c0.036-0.043,0.072-0.086,0.11-0.127c0.086-0.094,0.179-0.179,0.274-0.263 c0.018-0.015,0.036-0.03,0.055-0.045c-0.072,0.058,0.022-0.016,0.031-0.022c0.05-0.035,0.1-0.07,0.152-0.102 c0.119-0.074,0.243-0.141,0.372-0.197c-0.016,0.007-0.065,0.026,0.012-0.005c0.044-0.018,0.089-0.034,0.134-0.05 c0.073-0.025,0.148-0.048,0.223-0.069c0.152-0.041,0.368-0.084,0.475-0.096c0.436-0.051,0.878-0.033,1.313,0.02 c0.222,0.027,0.413-0.209,0.413-0.413c0-0.245-0.191-0.386-0.413-0.413c-1.34-0.161-2.805,0.09-3.714,1.173 c-0.599,0.715-0.891,1.61-0.984,2.527c-0.019,0.188-0.033,0.38-0.024,0.57 C578.686,187.625,579.512,187.628,579.487,187.096L579.487,187.096z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M578.999,202.906l-10.038,3.883l-1.799-1.089l0,0l-2.394-1.468l-5.015,7.207 c1.031,2.175,6.149,5.205,6.149,5.205l1.229-3.977c0.304,0.16,0.624,0.307,0.951,0.439c0.328,0.149,0.721,0.285,1.167,0.355 c0.019,0.003,0.04,0.011,0.059,0.015c0.013,0.002,0.021,0.003,0.033,0.005c0.003,0,0.005,0.001,0.007,0.001 c0.661,0.106,1.109,0.14,1.41,0.14l0.803,3.023c0,0,9.109-2.968,12.346-6.869L578.999,202.906z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M583.999,209.775l-4.927-6.869 l-10.091,3.889l2.625,9.85C571.606,216.645,580.749,213.677,583.999,209.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M564.787,204.232l4.194,2.563 l-3.056,9.85c0,0-5.138-3.03-6.172-5.205L564.787,204.232z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M567.19,212.568 c0,0,1.644,1.329,3.553,0.837"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#161522",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M559.118,215.068 c0,0,4.133,3.34,10.158,3.7c3.662,0.219,8.121-0.414,12.492-4.283"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#16004D"
    },
    points: "269.707,244.976 324.398,244.976 311.696,296.853 247.298,296.853  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5069FF"
    },
    points: "271.687,248.158 319.668,248.158 308.524,293.67 252.028,293.67  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "252.028,293.67 302.253,293.67 314.061,249.969 270.906,249.969  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "259.882,253.511 309.196,253.511 309.394,252.778 260.274,252.778  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "308.26,256.976 258.47,256.976 258.47,257.709 308.062,257.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "307.125,261.174 258.47,261.174 258.47,261.907 306.927,261.907  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "305.991,265.372 256.992,265.372 256.992,266.105 305.793,266.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "304.857,269.571 255.295,269.571 255.295,270.303 304.659,270.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "244.161,282.897 278.122,282.897 278.122,282.164 244.553,282.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "286.139,273.768 249.045,273.768 248.653,274.501 285.941,274.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#161522"
    },
    points: "285.004,277.967 246.799,277.967 246.407,278.699 284.806,278.699  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#16004D"
    },
    points: "572.688,296.801 561.655,249.485 477.845,249.485 490.576,297.66  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M258.674,364.792l7.43,65.051c0,0-14.694,4.561-17.996,0.051 c-3.302-4.509-14.364-63.781-14.364-63.781L258.674,364.792z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeMiterlimit: 10
    },
    x1: 233.743,
    y1: 366.113,
    x2: 247.777,
    y2: 433.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M248.759,451.726l-5.613-34.108l23.164-0.59l1.051,11.337c0,0,17.925,22.005,12.642,24.069 c-8.61,3.363-19.014-7.049-19.014-7.049l-0.673,6.951L248.759,451.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "266.309,417.029  243.145,417.619 248.988,452.378  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M278.945,364.792l7.43,65.051c0,0-14.694,4.561-17.996,0.051 c-3.302-4.509-14.364-63.781-14.364-63.781L278.945,364.792z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeMiterlimit: 10
    },
    x1: 254.014,
    y1: 366.113,
    x2: 268.048,
    y2: 433.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M269.03,451.726l-5.613-34.108l23.164-0.59l1.051,11.337c0,0,24.718,22.674,19.435,24.738 c-8.61,3.363-25.807-7.718-25.807-7.718l-0.672,6.951L269.03,451.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "286.58,417.029  263.416,417.619 269.259,452.378  "
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M204.552,306.68c0,0,35.269-3.382,54.154,3.624c20.473,7.595,27.302,78.725,27.302,78.725 l-72.888-0.623l-29.377-74.099L204.552,306.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.951,
    y: 305.864,
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 10.503,
    height: 147.069
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.122,
    y: 305.864,
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 10.503,
    height: 147.069
  })), /*#__PURE__*/React.createElement("rect", {
    x: 99.054,
    y: 297.31,
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 560.467,
    height: 11.224
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#92CDFE",
      strokeMiterlimit: 10
    },
    d: "M262.962,144.971h-33.187 c-4.24,0-7.677,3.267-7.677,7.297v12.878v4.504v14.109l7.806-6.812h33.058c4.24,0,7.677-3.267,7.677-7.297v-17.382 C270.64,148.238,267.202,144.971,262.962,144.971z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9999 0.0112 -0.0112 0.9999 238.779 171.7906)",
    style: {
      fill: "#FFFFFF",
      stroke: "#92CDFE",
      strokeMiterlimit: 10,
      fontFamily: "'Quicksand-Bold'",
      fontSize: "32.076px"
    }
  }, "?")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M260.329,242.404l14.333-15.475c0,0,5.806-14.858,9.151-13.671 c2.118,0.752-0.912,11.714-0.912,11.714l13.599-4.738c0,0,8.2-7.44,9.746-7.281c3.255,0.337-0.275,9.887-3.392,13.989 c-2.754,3.625-17.192,9.625-17.192,9.625l-12.625,17.836L260.329,242.404z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 307.414,
    y1: 214.04,
    x2: 300.107,
    y2: 224.383
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EF8576",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 306.715,
    y1: 219.251,
    x2: 303.262,
    y2: 224.16
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C8A6",
      stroke: "#EF8576",
      strokeWidth: 0.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 195.683,188.401 201.781,194.219 198.313,197.575  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.373,204.245c0.077,0.346,0.17,0.683,0.273,1.015 c-0.005,0.381,0.028,0.767,0.113,1.154L172.373,204.245l15.336,8.105l-0.015-0.069l4.577-1.014 c5.263-1.165,8.483-7.021,7.156-13.014l-2.717-12.271c-1.327-5.992-6.719-9.941-11.981-8.776l-7.916,1.753 c-5.263,1.165-8.483,7.021-7.157,13.013L172.373,204.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M199.427,198.254l-2.717-12.271c-1.327-5.992-6.719-9.941-11.982-8.776l-7.916,1.753 c-5.263,1.165-8.483,7.021-7.157,13.014l2.717,12.271c0.077,0.346,0.17,0.683,0.273,1.015 c-0.005,0.381,0.028,0.767,0.114,1.154l0.798,0.372l0.498,16.549h16.203l-0.758-11.453l2.772-0.614 C197.533,210.102,200.754,204.246,199.427,198.254z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M188.846,193.938c0.055,0.996,0.907,1.758,1.903,1.703 c0.996-0.055,1.758-0.907,1.702-1.903c-0.055-0.996-0.907-1.758-1.903-1.703S188.79,192.942,188.846,193.938z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M199.106,204.051c-0.033,0.021-0.067,0.04-0.101,0.059 c-0.038,0.021-0.078,0.041-0.117,0.06c-0.023,0.011-0.045,0.021-0.068,0.032c-0.095,0.044,0.022-0.007-0.043,0.018 c-0.316,0.124-0.656,0.211-0.98,0.237c-1.279,0.102-2.428-0.518-3.342-1.369c-0.353-0.328-0.885,0.201-0.53,0.53 c1.037,0.965,2.367,1.688,3.822,1.592c0.586-0.039,1.239-0.184,1.739-0.512 C199.887,204.435,199.511,203.786,199.106,204.051L199.106,204.051z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M186.928,191.962c0.771-0.903,1.625-1.731,2.552-2.473c0.158-0.127,0.132-0.398,0-0.53 c-0.156-0.156-0.372-0.127-0.53,0c-0.927,0.742-1.782,1.57-2.552,2.473c-0.131,0.154-0.151,0.379,0,0.53 C186.533,192.096,186.796,192.117,186.928,191.962L186.928,191.962z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8576"
    },
    d: "M189.869,201.104c0,2.452-1.988,4.44-4.44,4.44c-2.452,0-4.44-1.988-4.44-4.44 c0-2.452,1.988-4.44,4.44-4.44C187.882,196.664,189.869,198.652,189.869,201.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4040"
    },
    d: "M173.078,199.463l1.317-4.261c0,0,15.476-2.448,22.347-18.863 c2.553-6.1-1.77-11.92-8.803-11.973c-8.896-0.067-16.832,4.947-16.832,4.947s-20.606,9.456-13.952,30.307 c0,0,3.534,12.2,16.98,12.73"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -54.9434 272.6389)",
    style: {
      fill: "#7F4040"
    },
    cx: 144.776,
    cy: 171.031,
    rx: 14.636,
    ry: 14.636
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C8A6"
    },
    d: "M164.776,202.762c0.418,3.263,3.424,5.566,6.714,5.145c3.29-0.421,5.618-3.408,5.2-6.671 c-0.418-3.263-3.424-5.566-6.714-5.145C166.686,196.512,164.358,199.499,164.776,202.762z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF8576"
    },
    d: "M174.467,202.366c-0.095-1.491-0.972-3.02-2.452-3.481 c-0.773-0.241-1.609-0.172-2.386,0.01c-0.517,0.121-0.298,0.918,0.22,0.796c0.329-0.077,0.66-0.13,0.999-0.136 c0.143-0.003,0.287,0.002,0.43,0.016c0.105,0.01,0.212,0.028,0.361,0.065c0.273,0.069,0.38,0.112,0.601,0.238 c0.093,0.053,0.182,0.113,0.268,0.177c0.055,0.041-0.072-0.062,0.012,0.011c0.018,0.015,0.035,0.029,0.053,0.045 c0.043,0.037,0.085,0.076,0.125,0.115c0.072,0.07,0.137,0.145,0.203,0.221c0.076,0.088-0.011-0.023,0.055,0.071 c0.031,0.044,0.062,0.087,0.091,0.132c0.107,0.163,0.196,0.336,0.279,0.512c0.05,0.108-0.014-0.042,0.021,0.048 c0.015,0.04,0.031,0.079,0.046,0.118c0.031,0.084,0.059,0.168,0.085,0.254c0.042,0.137,0.077,0.275,0.106,0.415 c0.013,0.063,0.025,0.127,0.036,0.191c0.004,0.025,0.008,0.051,0.012,0.077c0.018,0.11-0.008-0.092-0.003-0.026 c0.003,0.043,0.01,0.086,0.013,0.129c0.014,0.223,0.18,0.413,0.413,0.413 C174.267,202.779,174.482,202.589,174.467,202.366L174.467,202.366z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M165.96,227.252l7.839-9.301l19.899,0.67l7.228,8.093 C200.926,226.714,187.431,227.252,165.96,227.252z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16004D"
    },
    d: "M209.829,283.347c18.65,10.63,35.981,16.316,42.47,12.176 c12.949-8.262,33.435-51.215,33.435-51.215l-20.969-12.852l-23.868,23.482c0,0-24.545-22.998-36.913-28.023 c-5.366-2.18-35.043-1.16-35.043-1.16s-2.919,0.894-4.294,1.498c-16.444,7.222-20.332,31.71-25.691,65.854l-0.123,3.775 l71.312,0.635L209.829,283.347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M285.734,244.308l-20.969-12.852 l-23.868,23.482c0,0-24.545-22.998-36.913-28.023c-5.366-2.18-32.589-1.231-32.589-1.231"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 240.322,
    y1: 254.404,
    x2: 245.801,
    y2: 259.938
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#6FBBEF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 260.329,
    y1: 235.82,
    x2: 282.712,
    y2: 250.4
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 207.568,
    y: 351.85,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 424.4011 763.8508)",
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    width: 9.265,
    height: 60.15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M209.354,431.205h5.693c2.369,0,4.29-1.921,4.29-4.29v-42.793c0-2.37-1.921-4.29-4.29-4.29 h-5.693c-2.369,0-4.29,1.921-4.29,4.29v42.793C205.064,429.284,206.985,431.205,209.354,431.205z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2E4ECC"
    },
    points: "175.641,426.903 177.915,426.903 246.486,426.903 251.878,426.903 251.878,433.086  251.878,440.042 246.486,440.042 246.486,433.086 177.915,433.086 177.915,440.042 172.524,440.042 172.524,433.086  172.524,426.903  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M166.899,443.595c0,4.567,3.702,8.269,8.27,8.269 c4.567,0,8.269-3.702,8.269-8.269c0-4.567-3.702-8.269-8.269-8.269C170.602,435.326,166.899,439.028,166.899,443.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M172,443.595c0,1.75,1.419,3.169,3.169,3.169c1.75,0,3.169-1.419,3.169-3.169 c0-1.75-1.419-3.169-3.169-3.169C173.419,440.427,172,441.845,172,443.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeMiterlimit: 10
    },
    d: "M241.198,443.595c0,4.567,3.702,8.269,8.269,8.269 c4.567,0,8.269-3.702,8.269-8.269c0-4.567-3.702-8.269-8.269-8.269C244.9,435.326,241.198,439.028,241.198,443.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4ECC"
    },
    d: "M246.299,443.595c0,1.75,1.419,3.169,3.169,3.169s3.169-1.419,3.169-3.169 c0-1.75-1.419-3.169-3.169-3.169S246.299,441.845,246.299,443.595z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M297.858,359.15H138.563 c-3.283,0-6.006-2.541-6.232-5.816l-6.979-100.89c-0.25-3.611,2.612-6.678,6.232-6.678h83.952 c3.063,0,5.675,2.221,6.166,5.245l14.683,90.399c0.491,3.024,3.103,5.245,6.166,5.245h55.307c2.696,0,5.088,1.729,5.932,4.29 l0,0C305.124,354.987,302.114,359.15,297.858,359.15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 132.733,
    y1: 269.158,
    x2: 204.965,
    y2: 269.158
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 132.733,
    y1: 292.18,
    x2: 209.078,
    y2: 292.18
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 137.394,
    y1: 315.201,
    x2: 213.739,
    y2: 315.201
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 137.394,
    y1: 338.222,
    x2: 213.739,
    y2: 338.222
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E4ECC",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 210.45,
    y1: 250.593,
    x2: 225.143,
    y2: 348.035
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161522"
    },
    d: "M38.817,454.714c5.939,0,11.879,0,17.818,0c16.019,0,32.037,0,48.056,0 c23.749,0,47.498,0,71.247,0c28.975,0,57.95,0,86.924,0c31.625,0,63.25,0,94.874,0c32.14,0,64.28,0,96.419,0 c29.763,0,59.526,0,89.289,0c25.242,0,50.483,0,75.725,0c18.148,0,36.295,0,54.443,0c8.574,0,17.159,0.124,25.733,0 c0.375-0.005,0.75,0,1.125,0c1.609,0,1.611-2.5,0-2.5c-5.939,0-11.879,0-17.818,0c-16.019,0-32.037,0-48.056,0 c-23.749,0-47.498,0-71.247,0c-28.975,0-57.95,0-86.924,0c-31.625,0-63.25,0-94.874,0c-32.14,0-64.279,0-96.419,0 c-29.763,0-59.526,0-89.289,0c-25.242,0-50.483,0-75.725,0c-18.148,0-36.295,0-54.443,0c-8.575,0-17.16-0.124-25.733,0 c-0.375,0.005-0.75,0-1.125,0C37.208,452.214,37.206,454.714,38.817,454.714L38.817,454.714z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLoan);
export default __webpack_public_path__ + "static/media/business-loan.6ec6382f7fa2b1be71a43efa5c3eb2b2.svg";
export { ForwardRef as ReactComponent };